module.exports = __webpack_public_path__ + "static/img/img-ptfw5.3f2822a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw5.png
// module id = sb/n
// module chunks = 0